import {getDictList} from "@/api/information";
import{systemList} from "@/api/company"; //查询企业账户 的所属行业
import { reject } from "lodash";
import { data } from "autoprefixer";

const state = {
    list: [],
    count:'',
    comany:[]
}

const mutations = {
    SET_INDUSTRY: (state, list) => {
        state.list = list
    },
    SET_Count:(state,count)=>{
        state.count = count
    },
    SET_INDUSTRYS:(state, comany)=>{
        state.comany = comany
    }
}

const actions = {
    getIndustry({ commit}){
          return new Promise((resolve,reject)=>{
            getDictList().then(res=>{
                resolve(res.data);
                commit('SET_INDUSTRY',res.data)
            })
          })
    },
    getComanyIndustry({commit}){
        return new Promise((resolve,reject)=>{
            systemList().then(res=>{
                resolve(res.data);
                commit('SET_INDUSTRYS',res.data)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/industry.js